const captions = {
  '1': {
    id: '1',
    display_id: '7',
    text1: 'Brilliant coronet part of the Hawaii Collection',
    text2: 'Could purchase 52,631 textbooks for students in grades 11 and 12.',
    object_ids: []
  },
  '2': {
    id: '2',
    display_id: '2',
    text1: 'A Belle Epoque platinum and diamond tiara by Cartier circa 1890.',
    text2: 'Could fund the treatment of 12,052 tuberculosis patients until their full recovery.',
    object_ids: [],
    names: []
  },
  '3': {
    id: '3',
    display_id: '5',
    text1: 'An Antique Ceylon sapphire and diamond necklace mounted in silver and gold by Van Cleef and Arpels.',
    text2: 'Could provide electricity to approximately 2,252 households in off-grid areas.',
    object_ids: ['3_Antique Ceylon Sapphire Necklace'],
    names: []
  },
  '4': {
    id: '4',
    display_id: '10',
    text1: 'A pearl and diamond set with earclips and brooch in yellow gold.',
    text2: 'Equivalent to the average annual income of 15 Filipinos.',
    object_ids: [],
    names: []
  },
  '5': {
    id: '5',
    display_id: '1',
    text1: 'An Antique tiara circa 1860 with Cabochon ruby, diamonds and Mabe pearl.',
    text2: 'Could finance the four-year tuition of 2,000 students in a Philippine state university.',
    object_ids: ['5_Antique tiara with Cabochon ruby'],
    names: []
  },
  '6': {
    id: '6',
    display_id: '4',
    text1: 'A matching set of antique diamond, sapphire and ruby bracelet, pendant and earrings mounted in silver and gold, circa 1860.',
    text2: 'Could finance the full immunization of 20,000 children (one dose of BCG, three doses each of OPV, DPT, and Hepatitis B vaccines, and one dose of measles) and provide 17,600 pneumococcal vaccines to senior citizens and infants.',
    object_ids: [],
    names: []
  },
  '7': {
    id: '7',
    display_id: '7',
    text1: 'A matching set of white gold bracelet, necklace, earrings, and brooch with cabochon rubies, diamond and cultured pearls.',
    text2: 'Could purchase 52,631 textbooks for students in grades 11 and 12.',
    object_ids: []
  },
  '8': {
    id: '8',
    display_id: '7',
    text1: 'A heart-shaped cabochon ruby weighing approximately 25-30cts. with diamond and white gold surround; and matching ruby, diamond and cultured pearl necklace, bracelet and earrings',
    text2: 'Could purchase 52,631 textbooks for students in grades 11 and 12.',
    object_ids: [],
    names: []
  },
  '9': {
    id: '9',
    display_id: '3',
    text1: 'An antique diamond and pearl tiara mounted in silver and gold.',
    text2: 'Could provide housing for 1,200 homeless beneficiaries.',
    object_ids: ['9_Antique diamond and pearl tiara']
  },
  '10': {
    id: '10',
    display_id: '11',
    text1: 'An antique intense pink Taviz-cut Golconda diamond.',
    text2: 'Equivalent to the combined construction of Bicol International Airport and the renovation of Sanga Sanga airport in Tawi Tawi province.',
    object_ids: []
  },
  '11': {
    id: '11',
    display_id: '6',
    text1: 'A matching necklace and earclip set in 18ct yellow gold, golden South Sea pearls and diamonds.',
    text2: 'Could support 310 indigenous family beneficiaries of the Pantawid Pamilyang Pilipino Program (the Philippine national poverty alleviation programme)',
    object_ids: [],
    names: []
  },
  '12': {
    id: '12',
    display_id: '9',
    text1: 'A large oval cabochon ruby and diamond brooch mounted in yellow gold.',
    text2: 'Could support 1726 agrarian reform beneficiaries by building farming capacities, providing access to services and developing enterprises.',
    object_ids: [],
    names: []
  },
  '13': {
    id: '13',
    display_id: '8',
    text1: 'A set of faceted emerald, diamond and pearl brooch and drop earrings in white gold.',
    text2: 'Equivalent to 15% of the total budget of the construction of Metro Manila Bus Rapid Transit-Line 2',
    object_ids: [],
    names: []
  }
}

const gallery = {

  '1': {
    id: '1',
    caption: 'Culture Center of the Philippines, Manilla',
    url: '/gallery/22-Culture-Center-of-the-Philippines.jpg'
  },

  '2': {
    id: '2',
    caption: 'Culture Center of the Philippines, Manilla',
    url: '/gallery/23-Culture-Center-of-the-Philippines.jpg'
  },

  '3': {
    id: '3',
    caption: 'Culture Center of the Philippines, Manilla',
    url: '/gallery/24-Culture-Center-of-the-Philippines.jpg'
  },

  '4': {
    id: '4',
    caption: 'Culture Center of the Philippines, Manilla',
    url: '/gallery/25-Culture-Center-of-the-Philippines.jpg'
  },

  '5': {
    id:'5',
    caption: 'Woolwich, London',
    url: '/gallery/1-Woolwich-London.jpg'
  },

  '6': {
    id:'6',
    caption: 'Cultural Center of the Philippines',
    url: '/gallery/2-Cultural-Center-of-the-Philippines.jpg'
  },

  '7': {
    id:'7',
    caption: 'Batanes, Philippines',
    url: '/gallery/3-Batanes-Philippines.jpg'
  },

  '8': {
    id:'8',
    caption: 'Bristol, United Kingdom',
    url: '/gallery/4-Bristol-United-Kingdom.jpg'
  },

  '9': {
    id:'9',
    caption: 'Central London',
    url: '/gallery/5-Central-London.jpg'
  },

  '10': {
    id:'10',
    caption: 'Fort Bonifacio, Manila',
    url: '/gallery/6-Fort-Bonifacio-Manila.jpg'
  },

  '11': {
    id:'11',
    caption: 'Quezon City, Philippines',
    url: '/gallery/7-Quezon-City-Philippines.jpg'
  },

  '12': {
    id:'12',
    caption: 'Royal Arsenal Riverside, London',
    url: '/gallery/8-Royal-Arsenal-Riverside-London.jpg'
  },

  '13': {
    id:'9',
    caption: 'New York City, United States',
    url: '/gallery/9-New-York-City-United-States.jpg'
  },
  
  '14': {
    id:'14',
    caption: 'Clerkenwell, London',
    url: '/gallery/10-Clerkenwell-London.jpg'
  },

  '15': {
    id:'11',
    caption: 'Deptford, London',
    url: '/gallery/11-Deptford-London.jpg'
  },

  '16': {
    id:'12',
    caption: 'Quezon City, Philippines',
    url: '/gallery/12-Quezon-City-Philippines.jpg'
  },

  '17': {
    id:'13',
    caption: 'Manila Bay, Philippines',
    url: '/gallery/13-Manila-Bay-Philippines.jpg'
  },

  '18': {
    id:'14',
    caption: 'Woolwich, London',
    url: '/gallery/14-Woolwich-London.jpg'
  },

  '19': {
    id:'15',
    caption: 'O\'ahu, Hawaii',
    url: '/gallery/15-Oahu-Hawaii.jpg'
  },

  '20': {
    id: '16',
    caption: 'East Avenue Hospital, Quezon City',
    url: '/gallery/15-East-Avenue-Hospital-Quezon-City.jpg'
  },

  '21': {
    id: '17',
    caption: 'Barnet, London',
    url: '/gallery/16-Barnet-London.jpg'
  },

  '22': {
    id: '18',
    caption: 'Makati City, Philippines',
    url: '/gallery/17-Makati-City-Philippines.jpg'
  },

  '23': {
    id: '19',
    caption: 'Taguig City, Metro Manila',
    url: '/gallery/18-Taguig-City-Metro-Manila.jpg'
  },

  '24': {
    id: '20',
    caption: 'Hastings, UK',
    url: '/gallery/19-Hastings-UK.jpg'
  },

  '25': {
    id: '21',
    caption: 'London, UK',
    url: '/gallery/20-London-UK.jpg'
  },

  '26': {
    id: '22',
    caption: 'Queens Park, London',
    url: '/gallery/21-Queens-Park-London.jpg'
  },






}

export {captions, gallery}
